import React from 'react';
import StyledBadge from '../styled/StyledBadge';
import { getDisplayValue, isInvalidValue } from './badge.utils';

const Badge = ({ count }) => {
  if (isInvalidValue(count)) {
    return null;
  }

  const displayValue = getDisplayValue(count);

  return (
    <StyledBadge>
      <div>{displayValue}</div>
    </StyledBadge>
  );
};

export default Badge;
